<div class="custom-radio-btn" [formGroup]="form">
  <div class="form-check" [class.align-items-start]="description">
    <input
      class="form-check-input position-relative"
      style="width: 20px; height: 20px"
      type="radio"
      [name]="input_name"
      [attr.name]="input_name"
      [formControlName]="input_name"
      id="{{ input_name }}{{ value }}"
      [attr.aria-labelledby]="input_name + value + '-label'"
      [value]="value"
      [checked]="checked"
      (change)="onRadioChange(value)"
      [disabled]="disabled" />
    <div class="d-flex flex-column spacing-8 align-items-start w-100 ms-2">
      <label
        class="form-check-label h4-bold primary-100"
        for="{{ input_name }}{{ value }}"
        id="{{ input_name }}{{ value }}-label"
        >{{ label }}</label
      >
      @if (description) {
        <div class="description h4-reg primary-60">
          {{ description }}
        </div>
      }
    </div>
  </div>
</div>
